(() => {
  if (window.MinireveCookieSkin) return;
  window.MinireveCookieSkin = true;

  const decorate = () => {
    const body = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body');
    const text = document.querySelector('meta[name="minireve-cookie-eyebrow"]')?.content;
    if (!body || !text || body.querySelector('.mr-cookie-eyebrow')) return;
    const label = document.createElement('span');
    label.className = 'mr-cookie-eyebrow';
    label.setAttribute('aria-hidden', 'true');
    label.textContent = text;
    body.prepend(label);
  };

  const start = () => {
    decorate();
    new MutationObserver(decorate).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-open-cookie-preferences]');
      if (!button || button.disabled) return;
      const error = button.parentElement.querySelector('.mr-cookie-preferences__error');
      error.hidden = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const deadline = Date.now() + 8000;
        while (!window.privacyBanner?.showPreferences && Date.now() < deadline) {
          await new Promise(resolve => setTimeout(resolve, 150));
        }
        if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
        await window.privacyBanner.showPreferences();
      } catch (_) {
        error.hidden = false;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
